import { render, staticRenderFns } from "./onlinesignature.vue?vue&type=template&id=3bdf3af2&scoped=true&"
import script from "./onlinesignature.vue?vue&type=script&lang=js&"
export * from "./onlinesignature.vue?vue&type=script&lang=js&"
import style0 from "./onlinesignature.vue?vue&type=style&index=0&id=3bdf3af2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdf3af2",
  null
  
)

export default component.exports